import { isExpired } from '../../../../commons/utils/token';
import { getAuthSession } from './api';

async function initDashboard() {
    const params = this.page.params;
    const authSession = getAuthSession();
    const token = params.token || authSession.token;
    const hasTokenIssue = await this.tokenExpired(token);

    const state = this.selectSessionAppState({ params, hasTokenIssue, authSession });
    this.stateRedirect({ state, params, authSession });
}

export async function tokenExpired(token) {
    if (!token) return true;
    return await isExpired(token);
}

export default initDashboard;
